// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e26ET3nUIVgKGlNZbykW {
  text-decoration: underline;
  display: inline-block;
  max-width: 100%;
  cursor: pointer;
}

.snnDEBexgjjtSK6xwTEe {
  display: flex;
  column-gap: 0.1rem;
  align-items: center;
  max-width: 100%;
}

.H1FkeNsUe7LSam6XvZfX {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.H1FkeNsUe7LSam6XvZfX .uQa_ROiOhQqytsONWCFq {
  text-align: center;
  padding-top: 1rem;
}

.cvRz8afRiJz6WOMSzXEP {
  display: inline-flex;
  vertical-align: middle;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/report_summary/cards/email_insights/email.module.scss"],"names":[],"mappings":"AACA;EACE,0BAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AAAF;AAEE;EACE,kBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,oBAAA;EACA,sBAAA;EACA,QAAA;AADF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.item_link {\n  text-decoration: underline;\n  display: inline-block;\n  max-width: 100%;\n  cursor: pointer;\n}\n\n.grid_element_with_classification {\n  display: flex;\n  column-gap: 0.1rem;\n  align-items: center;\n  max-width: 100%;\n}\n\n.attachments_grid {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n\n  .more_attachments {\n    text-align: center;\n    padding-top: 1rem;\n  }\n}\n\n.email_auth_counters {\n  display: inline-flex;\n  vertical-align: middle;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item_link": `e26ET3nUIVgKGlNZbykW`,
	"grid_element_with_classification": `snnDEBexgjjtSK6xwTEe`,
	"attachments_grid": `H1FkeNsUe7LSam6XvZfX`,
	"more_attachments": `uQa_ROiOhQqytsONWCFq`,
	"email_auth_counters": `cvRz8afRiJz6WOMSzXEP`
};
export default ___CSS_LOADER_EXPORT___;
